import React                  from 'react';
import PropTypes              from 'prop-types';
import Translations           from '../utils/Translations';
import ReloadHelper           from '../utils/ReloadHelper';
import {VXPay}                from '../utils/VXPay';
import Flux                   from '../flux/Flux';
import UrlBuilder             from "../utils/UrlBuilder";
import { trackUserMenuClick } from '../utils/GAHelper';

class GuestAvatar extends React.Component {

	constructor(props) {
		super(props);

		this.openVXPay      = this.openVXPay.bind(this);
		this.onBadgeClick   = this.onBadgeClick.bind(this);
	}

	openVXPay(e) {
		if (this.props.labelUrl === null) {
			return;
		} else if (this.props.labelUrl) {
			ReloadHelper.reload(this.props.labelUrl, e);
		} else if (!Flux.Guest.isVip()) {
			VXPay.openAboPaytour();
		}
	}

	onBadgeClick(e) {
		ReloadHelper.reload(UrlBuilder.buildVIP30Url(), e);
		trackUserMenuClick('guestavatar', UrlBuilder.buildVIP30Url());
	}

	render() {
		const styles = {
			width:  this.props.size + 'px',
			height: this.props.size + 'px',
		};

		let label   = '';
		let classes = '';
		if (this.props.label) {
			label = this.props.label;
		} else {
			if (this.props.isVip) {
				classes = ' is-vip';
				label   = <div className="h-color-text-dark" onClick={this.onBadgeClick}>VIP CLUB</div>;
			} else if (this.props.isPremium) {
				classes = ' is-premium';
				label   = Translations.get('PremiumTV');
			}
		}

		if (!this.props.guestUrlPreviewPicture) {
			classes += ' is-placeholder';
		}

		if (!Flux.Guest.isLoggedIn()) {
			classes += ' is-logged-out';
		}

		let imageWrapper = (
			<span className={"guest-avatar__image-wrapper"} style={styles}>
				{this.props.guestUrlPreviewPicture &&
				<span style={{'backgroundImage': `url("${this.props.guestUrlPreviewPicture}")`}}
				      className="guest-avatar__image"
				      alt={this.props.guestName}
				/>}
			</span>
		);

		if (this.props.imageLink && this.props.onImageClick) {
			imageWrapper = (
				<a href={this.props.imageLink} className="h-disp-inline-block h-cursor-pointer" onClick={this.props.onImageClick}>
					{imageWrapper}
				</a>
			);
		}

		return (
			<span className={"guest-avatar__container" + classes}>
				{this.props.isVip && <span className={"icon -icon-person-vip guest-avatar-crown"} />}
				{imageWrapper}
				{label && <span className="h-disp-block h-text-align-center"><span className={"guest-avatar__label -guest"}>{label}</span></span>}
			</span>
		);
	}
}

GuestAvatar.propTypes = {
	guestName:              PropTypes.string.isRequired,
	guestUrlPreviewPicture: PropTypes.string,
	isPremium:              PropTypes.bool,
	isVip:                  PropTypes.bool,
	label:                  PropTypes.string,
	labelUrl:               PropTypes.string,
	size:                   PropTypes.number,
	onImageClick:           PropTypes.func,
	imageLink:              PropTypes.string,
};

GuestAvatar.defaultProps = {
	guestUrlPreviewPicture: '',
	isVip:                  false,
	isPremium:              false,
	label:                  '',
	labelUrl:               '',
	size:                   80,
	imageLink:              '',
};

export default GuestAvatar;
